import ENV from 'root/lib/Env';
import { clearBrowserStorage } from 'lib/browserStorage';

// If you want to SKIP LOGIN in a "dev" environment, set this to TRUE.
// If you are commiting to master, this must be FALSE
const BYPASS_LOGIN = false;

export default () => {
  console.log('Redirecting');
  if (window && window.location && !BYPASS_LOGIN) {
    clearBrowserStorage();
    window.location.href = ENV.MAIN_APP_URL;
  }
};
